export const scrollHeader = () => {
  const headerElement = document.querySelector(".js-header");

  const HIDDEN_CLASS = "header--hidden";

  if (headerElement) {
    let prevScroll = window.pageYOffset;
    let currentScroll: number;

    const getPageHeight = (): number => Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight,
      document.body.clientHeight,
      document.documentElement.clientHeight,
    );

    const getHeaderHiddenStatus = (): boolean => headerElement.classList.contains(HIDDEN_CLASS);

    function onWindowScroll() {
      currentScroll = window.pageYOffset;

      if (currentScroll + window.innerHeight >= getPageHeight()) {
        prevScroll = currentScroll;
        return;
      }

      if (currentScroll > prevScroll && currentScroll >= 100 && !getHeaderHiddenStatus()) {
        headerElement?.classList.add(HIDDEN_CLASS);
      }

      if (currentScroll < prevScroll && getHeaderHiddenStatus()) {
        headerElement?.classList.remove(HIDDEN_CLASS);
      }
      prevScroll = currentScroll;
    }

    window.addEventListener("scroll", onWindowScroll);
  }
};
